import { ref } from "vue";

const isTaskCompleteModalOpen = ref(false);
const options = ref();

export function openTaskCompleteModal(optionsValue) {
  options.value = { ...options.value, ...optionsValue };

  isTaskCompleteModalOpen.value = true;
}

export function closeTaskCompleteModal() {
  isTaskCompleteModalOpen.value = false;
}

export function useTaskCompleteModal() {
  return {
    isTaskCompleteModalOpen,
    openTaskCompleteModal,
    closeTaskCompleteModal,
    options,
  };
}
